var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScene1Wysiwyg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 281.25,
    viewBox: "0 0 132.29 74.414",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-38.984 -10.451)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "palette",
    transform: "translate(69.537 16.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.39395,
    y: 10.977,
    width: 20.908,
    height: 40.223,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#aa9de2",
    strokeMiterlimit: 10,
    strokeWidth: 0.25873
  }), /*#__PURE__*/React.createElement("g", {
    className: "i-txt",
    transform: "translate(.26458 .26458)",
    stroke: "#babfc3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.9801,
    y: 12.828,
    width: 7.6815,
    height: 7.6815,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#b7b7e1",
    strokeMiterlimit: 10,
    strokeWidth: 0.25605
  }))), /*#__PURE__*/React.createElement("g", {
    className: "create-form",
    transform: "translate(-28.875 -84.766)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.16,
    y: 103.32,
    width: 37.042,
    height: 58.208,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#aa9de2",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScene1Wysiwyg);
export default __webpack_public_path__ + "static/media/scene1-wysiwyg.89885c76c084215539d692ff0a6ee546.svg";
export { ForwardRef as ReactComponent };